var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTogglelike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 5,
    stroke: "#34C759",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59375 16.3284V9.55511C9.59375 9.28844 9.67375 9.02844 9.82042 8.80844L11.6404 6.10177C11.9271 5.66844 12.6404 5.36177 13.2471 5.58844C13.9004 5.80844 14.3337 6.54177 14.1937 7.19511L13.8471 9.37511C13.8204 9.57511 13.8737 9.75511 13.9871 9.89511C14.1004 10.0218 14.2671 10.1018 14.4471 10.1018H17.1871C17.7137 10.1018 18.1671 10.3151 18.4337 10.6884C18.6871 11.0484 18.7337 11.5151 18.5671 11.9884L16.9271 16.9818C16.7204 17.8084 15.8204 18.4818 14.9271 18.4818H12.3271C11.8804 18.4818 11.2537 18.3284 10.9671 18.0418L10.1137 17.3818C9.78708 17.1351 9.59375 16.7418 9.59375 16.3284Z",
    fill: "#34C759"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47398 8.25391H6.78732C5.75398 8.25391 5.33398 8.65391 5.33398 9.64057V16.3472C5.33398 17.3339 5.75398 17.7339 6.78732 17.7339H7.47398C8.50732 17.7339 8.92732 17.3339 8.92732 16.3472V9.64057C8.92732 8.65391 8.50732 8.25391 7.47398 8.25391Z",
    fill: "#34C759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTogglelike);
export default __webpack_public_path__ + "static/media/togglelike.a53ee2a6b75b8ed61ab9fc6c67978990.svg";
export { ForwardRef as ReactComponent };